<div class="actions-container">
  <app-basic-list
    [dataItems]="dataItems"
    [platform]="platform"
    [title]="title"
    [dataCyTag]="'ingredient-details-touch'"
    (itemSelectedEvent)="handleTabSelection($event)"
    *ngIf="selectedTab === 'default'"
  >
  </app-basic-list>
  <div class="back-button" *ngIf="selectedTab !== 'default'">
    <ion-icon
      name="arrow-back-outline"
      (click)="handleBackButton('default')"
    ></ion-icon>
    <p>{{ title | translate }}</p>
  </div>
</div>
